var React = require('react');

function LowConfidence (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"7.62891","cy":"8.44849","r":"7.5","fill":"#FFE26E","key":0}),React.createElement("rect",{"x":"3.98828","y":"7.84851","width":"7.28346","height":"1.2","rx":"0.6","fill":"#432D4E","key":1})]);
}

LowConfidence.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = LowConfidence;

LowConfidence.default = LowConfidence;
